/* Palo Alto zoom-images custom element.
   Milano a11y rewrite (2026-08-05) of the stock minified file — behavior
   identical except createZoom builds the lightbox from VISIBLE triggers only:
   Grace's variant gallery hides non-matching media wrappers, and the stock
   version built slides from every [data-zoom-wrapper], so the lightbox cycled
   other variants' images. Falls back to the full list if the visibility
   filter leaves nothing (never a dead lightbox). */
!(function () {
  'use strict';
  customElements.get('zoom-images') ||
    customElements.define(
      'zoom-images',
      class extends HTMLElement {
        constructor() {
          super();
          this.mediaContainer = this.closest('[data-product-single-media-group]');
          this.slider = this.mediaContainer?.querySelector('[data-product-single-media-slider]');
          this.zoomWrappers = this.mediaContainer?.querySelectorAll('[data-zoom-wrapper]');
          this.a11y = window.theme.a11y;
        }
        connectedCallback() {
          // Delegated binding (2026-08-06): Grace's variant-media code replaces
          // gallery wrappers after load, which orphaned per-element listeners -
          // clicks on variant images did nothing. One listener on the container
          // with a live lookup survives any wrapper replacement.
          if (!this.mediaContainer) return;
          this.mediaContainer.addEventListener('click', (event) => {
            const wrapper = event.target && event.target.closest
              ? event.target.closest('[data-zoom-wrapper]')
              : null;
            if (!wrapper || !this.mediaContainer.contains(wrapper)) return;
            event.preventDefault();
            if (this.slider && this.slider.classList.contains('is-moving')) return;
            this.a11y.state.trigger = wrapper;
            this.createZoom(wrapper);
          });
        }
        createZoom(clickedWrapper) {
          const all = this.mediaContainer.querySelectorAll('[data-zoom-wrapper]');
          let wrappers = Array.prototype.filter.call(all, (el) => el.offsetParent !== null);
          if (!wrappers.length) wrappers = Array.prototype.slice.call(all);
          let index = wrappers.indexOf(clickedWrapper);
          if (index === -1) index = 0;
          const items = wrappers.map((el) => ({
            src: el.getAttribute('href'),
            w: parseInt(el.getAttribute('data-image-width')),
            h: parseInt(el.getAttribute('data-image-height')),
            msrc: el.getAttribute('href'),
          }));
          let mainClass = 'pswp-zoom-gallery';
          if (items.length === 1) mainClass = 'pswp-zoom-gallery pswp-zoom-gallery--single';
          const options = {
            barsSize: { top: 60, bottom: 60 },
            history: false,
            focus: false,
            index: index,
            mainClass: mainClass,
            showHideOpacity: true,
            showAnimationDuration: 250,
            hideAnimationDuration: 250,
            closeOnScroll: false,
            closeOnVerticalDrag: false,
            captionEl: false,
            closeEl: true,
            closeElClasses: ['caption-close'],
            tapToClose: false,
            clickToCloseNonZoomable: false,
            maxSpreadZoom: 2,
            loop: true,
            spacing: 0,
            allowPanToNext: true,
            pinchToClose: false,
          };
          new window.theme.LoadPhotoswipe(items, options);
        }
      }
    );
})();
